module.exports = __webpack_public_path__ + "static/media/cc_ghrcem.58893412.png";